<template>
  <div
    v-tooltip="fullOptions"
    class="base-hint"
  >
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M14 28C10.2807 28 6.70176 26.53 4.10526 23.87C-1.36842 18.41 -1.36842 9.52 4.10526 4.06C6.70176 1.47 10.2807 0 14 0C17.7193 0 21.2982 1.47 23.8947 4.13C29.3684 9.59 29.3684 18.48 23.8947 23.94C21.2982 26.53 17.7193 28 14 28ZM14 1.4C10.6316 1.4 7.47369 2.73 5.08772 5.11C0.175439 10.01 0.175439 17.99 5.08772 22.96C7.47369 25.27 10.6316 26.6 14 26.6C17.3684 26.6 20.5263 25.27 22.9123 22.89C27.8246 17.99 27.8246 10.01 22.9123 5.04C20.5263 2.73 17.3684 1.4 14 1.4ZM15.0526 8.75C14.7719 9.03 14.4912 9.1 14.1404 9.1C13.7895 9.1 13.4386 8.96 13.2281 8.75C12.9474 8.47 12.8772 8.19 12.8772 7.84C12.8772 7.49 13.0175 7.14 13.2281 6.93C13.5088 6.65 13.7895 6.58 14.1404 6.58C14.4912 6.58 14.7719 6.72 15.0526 6.93C15.3333 7.21 15.4035 7.49 15.4035 7.84C15.4035 8.19 15.3333 8.54 15.0526 8.75ZM13.1579 20.72V11.27C13.1579 11.13 13.2982 10.99 13.4386 10.99H14.8421C14.9825 10.99 15.1228 11.13 15.1228 11.27V20.79C15.1228 20.93 14.9825 21.07 14.8421 21.07H13.4386C13.2982 21 13.1579 20.86 13.1579 20.72Z"
        fill="#111111"
      />
    </svg>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { VTooltip } from 'v-tooltip'
  import { mapState, mapGetters } from 'vuex'
  import { get } from 'lodash'

  Vue.directive('tooltip', VTooltip)

  export default {
    name: 'BaseHint',

    props: {
      options: {
        type: Object,
        default: () => ({})
      },
      hintText: {
        type: String,
        default: ''
      },
      placementCenter: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        fullOptions: {}
      }
    },

    computed: {
      ...mapGetters(['isMobile', 'isLessDesctop']),
      ...mapState(['general']),
      hintMsg () {
        return get(this, 'general.vin-checker.hint')
      }
    },

    mounted () {
      if (this.placementCenter) {
        this.$set(this.fullOptions, 'boundariesElement', document.body)
      }

      this.placementCenter ? this.$set(this.fullOptions, 'placement', 'top-center') : this.$set(this.fullOptions, 'placement', this.isMobile ? 'top-end' : 'top-center')
      this.hintText ? this.$set(this.fullOptions, 'content', this.hintText) : this.$set(this.fullOptions, 'content', this.hintMsg)

      this.$set(this.fullOptions, 'trigger', this.isLessDesctop ? 'click' : 'hover')

      this.fullOptions = { ...this.fullOptions, ...this.options }
    }
  }
</script>
